import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import ArrowIcon from 'assets/images/login/icon-arrow.svg'

const useStyles = makeStyles((theme) => ({
  button: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '55px',
    padding: '0px 20px',
    borderRadius: '6.4px',
    border: `solid 0.8px ${theme.borderColor}`,
    outline: 'none',
    overflow: 'hidden',
    background: theme.nextButton,
    color: theme.white,
    width: '100%',
    '&:hover:not(:disabled)': {
      background: theme.colorPrimaryButtonBackgroundHover,
    },
  },
  iconLast: {
    marginLeft: 11,
  },
  iconFirst: {
    marginRight: 11,
  },
  disabled: {
    opacity: '0.7',
    background: theme.primaryDark,
  },
}))

/**
 * This is basically the base button with a hardcoded icon in it.
 *
 * Why?
 *
 * Because at this time we do have a couple of different approaches for buttons.
 *
 * First we need a clear concept how a button should behave in style, behavior and function,
 * then we have to refactor this one.
 *
 */
const ButtonNext = (props) => {
  const {
    type = 'button', label, disabled, onClick, customClass,
    width = '19px',
    height = '11px',
    iconPosFirst = false,
    iconFill = null,
    hideIcon = false,
    dataQsId,
    ...otherProps
  } = props
  const classes = useStyles()
  const icon = !hideIcon && <SVGIcon width={width} height={height} svg={ArrowIcon} customClass={iconPosFirst ? classes.iconFirst : classes.iconLast} fill={iconFill} />

  const content = iconPosFirst
    ? <>{icon}{label}</>
    : <>{label}{icon}</>

  return (
    <button
      data-qs-id={dataQsId}
      type={type}
      disabled={disabled}
      className={`${classes.button} ${disabled ? classes.disabled : ''} ${customClass || ''}`}
      onClick={onClick}
      {...otherProps}>
      {content}
    </button>
  )
}

ButtonNext.propTypes = {
  label: PropTypes.string,
  customClass: PropTypes.string,
  onClick: PropTypes.func,
  iconPosFirst: PropTypes.bool,
  iconFill: PropTypes.string,
  disabled: PropTypes.bool,
  dataQsId: PropTypes.string.isRequired,
}
export default ButtonNext
